// extracted by mini-css-extract-plugin
export default {"flex":"Strategies_flex__iM+sT"};